import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";

@Component({
  selector: "app-skeleton-table-item",
  imports: [CommonModule],
  templateUrl: "./skeleton-table-item.component.html",
  styleUrl: "./skeleton-table-item.component.scss",
})
export class SkeletonTableItemComponent {}
